<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Consumption') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('comparison_tooltip_consumption')"></i>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" id="canvas-consumptioncurve"></div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'ConsumptionComparison',
  components: {
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
      clock: null,
      sec: 0
    }
  },
  mounted(){
     const self = this
     this.chart = Highcharts.chart('canvas-consumptioncurve', {
          chart: {
              zoomType: '',
              backgroundColor: '#fff'
          },
          credits: {
              enabled: false
          },
          title: {
              text: null
          },
          xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                  day: '%H:%M'
              },
              
          },
          yAxis: {
              title: {
                  text: null,
              }
          },
          legend: {
              enabled: true
          },
          tooltip: {
              shared: true,
              pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.2f}</b> W',
              xDateFormat: this.$i18n.t('Consumption')+' '+this.$i18n.t('at')+' %H:%M'
          },
          plotOptions: {
              area: {
                  fillColor: {
                      linearGradient: {
                          x1: 0,
                          y1: 0,
                          x2: 0,
                          y2: 1
                      },
                      stops: [
                          [0, Highcharts.getOptions().colors[0]],
                          [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                      ]
                  },
                  marker: {
                      radius: 2
                  },
                  lineWidth: 1,
                  states: {
                      hover: {
                          lineWidth: 1
                      }
                  },
                  threshold: null
              },
              series: {
                  marker: {
                      enabled: false
                  },
                  events: {
                    legendItemClick: function () {
                      if (this.visible) _paq.push(['trackEvent', 'Comparação', 'Gráfico Curva de consumo', 'Esconder (' + this.name + ')'])                        
                      else _paq.push(['trackEvent', 'Comparação', 'Gráfico Curva de consumo', 'Mostrar (' + this.name + ')'])
                    },
                    mouseOver: function () {
                      self.clock = setInterval(function(){ self.sec++;  }, 1000)
                    },
                    mouseOut: function () {
                      clearInterval(self.clock);
                      if (self.sec > 1) _paq.push(['trackEvent', 'Comparação', 'Gráfico Curva de consumo', 'MouseOver (' + this.name + ')', sec])
                      self.sec = 0
                    }
                  }
              },
          },
          exporting: false,
          series: [{
              type: 'spline',
              name: this.$i18n.t('Date')+' 1',
              color: 'rgba(51,204,153,0.7)',
              data: []
          },
          {
              type: 'spline',
              name: this.$i18n.t('Date')+' 2',
              color: '#00735a',
              data: []
          }
          ]
      })
  },
  methods: {
    set_values: function(){
      let tooltip_format = this.$i18n.t('Consumption')+' '+this.$i18n.t('at')+' %H:%M'
      let legend1 = null
      let legend2 = null
      const datetime1 = moment(this.datetime1)
      const datetime2 = moment(this.datetime2) 
      const timezone = this.$store.getters.timezone
      let datetimeUTC = moment.tz(datetime1.format('YYYY-MM-DD'), timezone).toJSON()
      let datetimeUTC2 = moment.tz(datetime2.format('YYYY-MM-DD'), timezone).toJSON()
      if(this.range == 'day'){ 
        legend1 = moment(datetime1).format('DD MMM YYYY')
        legend2 = moment(datetime2).format('DD MMM YYYY')
        this.chart.series[0].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[1].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[0].setData(this.data[0].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC, timezone).hours(0).minutes(-1), moment.tz(datetimeUTC, timezone).hours(23).minutes(59))
        }).map(r => [moment.tz(timezone).hour(moment.tz(r.datetime, timezone).hours()).minute(moment.tz(r.datetime, timezone).minutes()).seconds(0).milliseconds(0).valueOf(), r.House]), false)
        this.chart.series[1].setData(this.data[1].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC2, timezone).hours(0).minutes(-1), moment.tz(datetimeUTC2, timezone).hours(23).minutes(59))
        }).map(r => [moment.tz(timezone).hour(moment.tz(r.datetime, timezone).hours()).minute(moment.tz(r.datetime, timezone).minutes()).seconds(0).milliseconds(0).valueOf(), r.House]), false)
      } 
      else if (this.range == 'week') {
        tooltip_format = this.$i18n.t('Consumption')+' - %a '+this.$i18n.t('at')+' %H:%M'
        legend1 = moment(datetime1).format('DD') +'-' + moment(datetime1).add(6, "days").format('DD MMM YYYY')
        legend2 = moment(datetime2).format('DD') +'-' + moment(datetime2).add(6, "days").format('DD MMM YYYY')
        datetimeUTC = moment.tz(datetime1.day(1).format('YYYY-MM-DD'), timezone).toJSON()
        datetimeUTC2 = moment.tz(datetime2.day(1).format('YYYY-MM-DD'), timezone).toJSON()
        this.chart.xAxis[0].update({ dateTimeLabelFormats: {day: "%a"}}, false)
        this.chart.series[0].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[1].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[0].setData(this.data[0].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC, timezone).hours(0).minutes(-1), moment.tz(datetimeUTC, timezone).add(6, 'days').hours(23).minutes(59))
        }).map(r => [Date.UTC(2018,0, moment.tz(r.datetime, timezone).day() ? moment.tz(r.datetime, timezone).day() : 7, moment.tz(r.datetime, timezone).hours()), r.House]), false)
        this.chart.series[1].setData(this.data[1].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC2, timezone).hours(0).minutes(-1), moment.tz(datetimeUTC2, timezone).add(6, 'days').hours(23).minutes(59))
        }).map(r => [Date.UTC(2018,0, moment.tz(r.datetime, timezone).day() ? moment.tz(r.datetime, timezone).day() : 7, moment.tz(r.datetime, timezone).hours()), r.House]), false)
      }
      else if (this.range == 'month') {
        tooltip_format = this.$i18n.t('Consumption')+' - Dia %a '+this.$i18n.t('at')+' %H:%M'
        legend1 = moment(datetime1).format('MMM YYYY')
        legend2 = moment(datetime2).format('MMM YYYY')
        datetimeUTC = moment.tz(datetime1.format('YYYY-MM'), timezone).toJSON()
        datetimeUTC2 = moment.tz(datetime2.format('YYYY-MM'), timezone).toJSON()
        this.chart.xAxis[0].update({ dateTimeLabelFormats: {day: "%e"}}, false);
        this.chart.series[0].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[1].update({ tooltip: { xDateFormat: tooltip_format }}, false)
        this.chart.series[0].setData(this.data[0].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC, timezone).startOf('month'), moment.tz(datetimeUTC, timezone).endOf('month'))
        }).map(r => [(moment(r.datetime).tz(timezone)).month(0).valueOf(), r.House]), false)
        this.chart.series[1].setData(this.data[1].filter(r => {
          return moment(r.datetime).isBetween(moment.tz(datetimeUTC2, timezone).startOf('month'), moment.tz(datetimeUTC2, timezone).endOf('month'))
        }).map(r => [(moment(r.datetime).tz(timezone)).month(0).valueOf(), r.House]), false)
      }
      
      this.chart.series[0].update({ name: legend1 }, false)
      this.chart.series[1].update({ name: legend2 }, false)
      
      if(!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t("No_Data"))
      }
      this.chart.redraw()
    }
  },
  watch:{
    data: function(){
      this.set_values()
    },
    current_lang: function(){
      this.set_values()
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data_consumption_comparison
    },
    range: function(){
      return this.$store.getters.selected_range
    },
    datetime1: function(){
      return this.$store.getters.datetime1
    },
    datetime2: function(){
      return this.$store.getters.datetime2
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
